/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Accordion, Card } from "react-bootstrap";
import { SimpleCheckBoxCoberturas } from 'components/InputsMex/SimpleInputs';

const acordeon = ({   
  detail=false,
  title='Coberturas adicionales',
  dataCoberturas=[],
  onSelectAllCoberturas
}) => {    
  return (
    <React.Fragment>
      <div className='container-fluid'>
        <div className='row my-5'>        
        <div className='col-12'>               
            <Accordion>             
                <div className='col-12'>                     
                    <Accordion.Toggle className='accordeon-item-mrn' as={Card.Header} eventKey="0" >
                    <table width="100%">
                        <tr>
                            <td>{title}</td>
                            <td className="d-flex justify-content-center"><i class="pi pi-chevron-down" style={{fontSize:"20px", color:"#a9a6a6"}}></i></td>
                        </tr>
                    </table>                                                                                      
                    </Accordion.Toggle>                                                                                                           
                  </div>
                  <div className='col-12 col-md-4'></div>
                  <Accordion.Collapse eventKey="0">                      
                      <div className='col-12 py-3'> 
                          <div className='background-chakMarine py-4 px-5'>
                              {detail == false &&
                                <div className='row col-12 cls-backgroun-cob' >
                                  <SimpleCheckBoxCoberturas
                                    name={`seleccionarTodasAdicionales`}
                                    id={`seleccionarTodasAdicionales`}
                                    label={'Seleccionar todo'}                                 
                                    labelClass={'form-check-label ml-4 cl-label-cob-new bg-transparent'}       
                                    rules={{
                                      validate: {
                                        checked: (value) => {
                                          if (value) {
                                            return onSelectAllCoberturas('activar')
                                          }
                                          return onSelectAllCoberturas('desactivar')
                                        },
                                      },
                                    }}                                                                                  
                                  /> 
                                </div> 
                              }                             
                              {/* <div className='row' >                                                                     */}
                                    {detail == false &&                                         
                                      dataCoberturas?.map((item) => (
                                        <div className='row col-12 cls-backgroun-cob' >
                                          <SimpleCheckBoxCoberturas
                                              name={`coberturasAdicionales.${item?.value}`}
                                              id={`coberturasAdicionales.${item?.value}`}
                                              label={item?.label}                                 
                                              labelClass={'form-check-label ml-4 cl-label-cob-new'}                                                        
                                            />   
                                        </div> 
                                      ))                                                                           
                                                                                 
                                    }
                                    {detail && 
                                      <div className='col-12 d-flex cls-backgroun-cob' >
                                        <div className='col-12' style={{margin:"0em 0em 1em 0em"}}>
                                            {
                                              dataCoberturas?.map((item) => (
                                                <label className='cl-label-cob-d'>{item?.label}</label>    
                                            ))
                                            }
                                        </div>   
                                      </div>                                 
                                    }                                                                                                     
                              {/* </div>                                                                                                                                 */}
                          </div>                                                    
                      </div>
                  </Accordion.Collapse>              
            </Accordion>            
          </div>                  
        </div>
      </div>      
    </React.Fragment>
  );
};

export default acordeon;

